import { NgModule } from "@angular/core";
import { NoPreloading, RouterModule, Routes } from "@angular/router";
import { NavRoleGuard } from "./lib/guards/NavRoleGuard"
import { AdminRoleGuard } from "./lib/guards/AdminRoleGuard"
import { LandingPageModule } from "./landing/landing.module";

const routes: Routes = [
  {
    path: "landing",
    loadChildren: () => import("./landing/landing.module").then((m) => m.LandingPageModule),
  },
  {
    path: "home",
    loadChildren: () => import("./patient/home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "admin/home",
    loadChildren: () => import("./admin/admin-home/admin-home.module").then((m) => m.AdminHomePageModule),
    canActivate: [AdminRoleGuard]
  },
  {
    path: "navigator/home",
    loadChildren: () =>
      import("./navigator/navigator-home/navigator-home.module").then((m) => m.NavigatorHomePageModule),
    canActivate: [NavRoleGuard]
  },

  {
    path: "settings",
    loadChildren: () => import("./settings/settings.module").then((m) => m.SettingsPageModule),
  },
  {
    path: "licenses",
    loadChildren: () => import("./licenses/licenses.module").then((m) => m.LicensesPageModule),
  },

  {
    path: "survey/:id",
    loadChildren: () => import("./survey/survey.module").then((m) => m.SurveyPageModule),
  },

  {
    path: "resources",
    loadChildren: () => import("./patient/resources/resources.module").then((m) => m.ResourcesPageModule),
  },

  {
    path: "navigator/view-patients",
    loadChildren: () => import("./navigator/view-patients/view-patients.module").then((m) => m.ViewPatientsModule),
    canActivate: [NavRoleGuard]
  },

  // Could also put a 404 here
  {
    path: "**",
    pathMatch: "full",
    loadChildren: () => LandingPageModule,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      //enableTracing: true,
      //useHash: true,
      preloadingStrategy: NoPreloading,
      //initialNavigation: 'disabled',
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
